"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StartCommand = void 0;
const Player_1 = require("../../common/Player");
const Command_1 = require("../Command");
const CommandType_1 = require("../lib/CommandType");
/**
 * Marks the beginning of the course. If this command has the arguments "P1" or
 * "P2", it will mark it as the chart for the first or second player
 * respectively, but only if same difficulty is picked by both players.
 */
class StartCommand extends Command_1.Command {
    constructor(player) {
        super(CommandType_1.CommandType.Start);
        this.player = player;
    }
    static parse(args) {
        const command = new StartCommand();
        if (args.length > 0) {
            const player = args[0].toUpperCase();
            switch (player) {
                case 'P1':
                    command.player = Player_1.Player.Player1;
                    break;
                case 'P2':
                    command.player = Player_1.Player.Player2;
                    break;
            }
        }
        return command;
    }
    toString() {
        let playerString;
        switch (this.player) {
            case Player_1.Player.Player1:
                playerString = 'P1';
                break;
            case Player_1.Player.Player2:
                playerString = 'P2';
                break;
        }
        if (playerString) {
            return `${super.toString()} ${playerString}`;
        }
        else {
            return super.toString();
        }
    }
}
exports.StartCommand = StartCommand;
